import { registerPlugin } from "@capacitor/core";
export * from "./definitions";
export const AssignmentBrowser = registerPlugin("AssignmentBrowser", {
    web: () => import("./web").then((m) => new m.AssignmentBrowserWeb()),
});
